// extracted by mini-css-extract-plugin
export default {"editProfileImage":"styles_editProfileImage__NOSyY","othersCard":"styles_othersCard__Ymu5u","savebutton":"styles_savebutton__m2BEs"};